import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import API_CONFIG, { buildApiUrl, buildApiUrlWithParams } from '../config/api';

const StudentRoles = () => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userGroups, setUserGroups] = useState([]);
    const [editingRole, setEditingRole] = useState(null);
    const [newRole, setNewRole] = useState({
        student_role_desc: ''
    });
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }

        const decoded = JSON.parse(atob(token.split(".")[1]));
        setUserGroups(decoded["cognito:groups"]);

        fetchRoles();
    }, [navigate]);

    const fetchRoles = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.STUDENT_ROLES), {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = await response.json();
            setRoles(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching roles:', error);
            setLoading(false);
        }
    };

    const handleEdit = (role) => {
        setEditingRole({ ...role });
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.STUDENT_ROLES), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(editingRole)
            });

            if (response.ok) {
                setEditingRole(null);
                fetchRoles();
            }
        } catch (error) {
            console.error('Error updating role:', error);
        }
    };

    const handleDelete = async (roleId) => {
        if (window.confirm('Are you sure you want to delete this role?')) {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(buildApiUrlWithParams(API_CONFIG.ENDPOINTS.STUDENT_ROLE_DETAIL, roleId), {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    fetchRoles();
                }
            } catch (error) {
                console.error('Error deleting role:', error);
            }
        }
    };

    const handleAdd = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.STUDENT_ROLES), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newRole)
            });

            if (response.ok) {
                setNewRole({
                    student_role_desc: ''
                });
                fetchRoles();
            }
        } catch (error) {
            console.error('Error adding role:', error);
        }
    };

    const isAdmin = userGroups.includes('mtkd-admin');

    if (loading) {
        return (
            <div className="container">
                <Navbar groups={userGroups}/>
                <div className="card">
                    <div className="card-body">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <Navbar groups={userGroups}/>
            <div className="card">
                <div className="card-body">
                    <h2 className="card-title">Student Roles</h2>
                    {isAdmin && (
                        <div className="mb-3">
                            <h4>Add New Role</h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Role Description"
                                        value={newRole.student_role_desc}
                                        onChange={(e) => setNewRole({ ...newRole, student_role_desc: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <button className="btn btn-primary" onClick={handleAdd}>Add Role</button>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Role Description</th>
                                    {isAdmin && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {roles.map(role => (
                                    <tr key={role.student_role_id}>
                                        <td>{role.student_role_id}</td>
                                        <td>
                                            {editingRole && editingRole.student_role_id === role.student_role_id ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editingRole.student_role_desc}
                                                    onChange={(e) => setEditingRole({ ...editingRole, student_role_desc: e.target.value })}
                                                />
                                            ) : (
                                                role.student_role_desc
                                            )}
                                        </td>
                                        {isAdmin && (
                                            <td>
                                                {editingRole && editingRole.student_role_id === role.student_role_id ? (
                                                    <button className="btn btn-success me-2" onClick={handleSave}>Save</button>
                                                ) : (
                                                    <button className="btn btn-primary me-2" onClick={() => handleEdit(role)}>Edit</button>
                                                )}
                                                <button className="btn btn-danger" onClick={() => handleDelete(role.student_role_id)}>Delete</button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentRoles; 